import { Modal } from 'react-bootstrap';
import React, { ReactNode } from 'react';

interface Props {
    setData: (it: { open: boolean; RenderData: ReactNode }) => void;
    setParam: (it: AnyObject) => void;
    data: { open: boolean; RenderData: ReactNode; params?: AnyObject };
}

const ModalEvent: React.FunctionComponent<Props> = ({ setData, data, setParam }: Props) => {
    const handleClose = () => {
        setData({ open: false, RenderData: '' });
    };
    return (
        <>
            <Modal show={data.open} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>{data.RenderData}</Modal.Body>
                {/*  <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() => {
                            setParam(data.params ? data.params : {});
                            handleClose();
                        }}
                    >
                        Yes
                    </Button>
                </Modal.Footer>*/}
            </Modal>
        </>
    );
};

export default ModalEvent;
